/** One hairline on the `line` token. */
import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

import {useV2Theme} from '../theme/useV2Theme';

const HAIRLINE = 1;

function Divider({style}: {style?: StyleProp<ViewStyle>}) {
  const tokens = useV2Theme(s => s.tokens);
  return <View style={[styles.line, {backgroundColor: tokens.line}, style]} />;
}

const styles = StyleSheet.create({
  line: {
    height: HAIRLINE,
    alignSelf: 'stretch',
  },
});

export default React.memo(Divider);
